
import React      from 'react'
import PropTypes  from 'prop-types'

import LogDetails from './LogDetails'

import api from '../redux/api'

export default class BatchDeliveryManagerLogDetails extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
  }

  render() {
    return <LogDetails match={this.props.match} getLogFn={api.loadBatchDeliveryManagerLog} />
  }
}